export default __webpack_public_path__ + "0a96a5e8e3a0f41b211cf38660c4e618.png";